import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import './MobileBottomNav.css';

export default function MobileBottomNav() {
  const location = useLocation();
  const { isAuthenticated, user } = useSelector(state => state.authState);

  if (!isAuthenticated) return null;

  const isAdminOrManager = user?.role === 'admin' || user?.role === 'manager' || user?.role === 'master';
  const isActive = (path) => location.pathname === path;

  return (
    <div className="mobile-bottom-nav d-md-none">
      <Link 
        to="/dashboard" 
        className={`nav-tab ${isActive('/dashboard') ? 'active' : ''}`}
      >
        <i className="fa fa-th-large"></i>
        <span>Dashboard</span>
      </Link>

      <Link 
        to="/patients" 
        className={`nav-tab ${isActive('/patients') ? 'active' : ''}`}
      >
        <i className="fa fa-user-injured"></i>
        <span>Patients</span>
      </Link>

      {isAdminOrManager && (
        <Link 
          to="/admin/billing" 
          className={`nav-tab ${isActive('/admin/billing') ? 'active' : ''}`}
        >
          <i className="fa fa-file-invoice-dollar"></i>
          <span>Billing</span>
        </Link>
      )}

      {isAdminOrManager && (
        <Link 
          to="/admin/attendance" 
          className={`nav-tab ${isActive('/admin/attendance') ? 'active' : ''}`}
        >
          <i className="fa fa-calendar-check"></i>
          <span>Attendance</span>
        </Link>
      )}

      {isAdminOrManager && (
        <Link 
          to="/admin/accounts" 
          className={`nav-tab ${isActive('/admin/accounts') ? 'active' : ''}`}
        >
          <i className="fa fa-wallet"></i>
          <span>Accounts</span>
        </Link>
      )}
    </div>
  );
}

